<div class="chart-box" [ngClass]="{'small-widget' : showSmallWidget}">
  <canvas #chartCanvas [id]="'widget-gauge-chart-' + widgetType"></canvas>
</div>
<div class="middle-text">
  {{customMiddleText}}
</div>
